module.exports = __webpack_public_path__ + "img/con1.cf39925e.png";